<template>
  <nav
    ref="menuEl"
    :class="['notification-banner']"
  >
    <div class="notification-container">
      <div class="icon-label">
        <img
          src="@assets/images/handover_notification/handover-notification.svg"
          alt="Notification Icon"
          width="20"
        />
        <span class="electronic-handover">
          An electronic handover has been initiated.
        </span>

        <span>
          <button class="view-details-button" @click="onViewDetails">
            View Details
          </button>
        </span>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'HandoverNotificationBanner',

  mounted() {
    this.$options._componentTag = 'nav';
  },
  methods: {
    onViewDetails() {
      this.$emit('view-details');
    },
  },
};
</script>
<style lang="scss">
@import '@variables';

.icon-label {
  display: flex;
  align-items: center;

  img {
    display: block;
    width: 20px;
    height: 20px;
    object-fit: contain;
    margin-right: 4px;
  }
}

.notification-banner {
  width: 100%;
  background-color: #FAEBD7;
  color: #fff;
  z-index: 10;

  .electronic-handover {
    color: var(--Validation-Colours-Warning-warning-500, #613B0C);
    font-size: 14px;
    font-family: "SF Pro Display", sans-serif;
    font-weight: 500;
    word-wrap: break-word;
  }

  .notification-container {
    display: flex;
    align-items: center;
    padding: 1rem 1rem;
  }

  .view-details-button {
    margin-left: 1rem;
    background-color: #5c4420;
    color: #ffffff;
    border: none;
    border-radius: 0.25rem;
    padding: 10px 8px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: background-color 0.1s ease-in-out;

    &:hover {
      background-color: darken(#5c4420, 10%);
    }
  }
}
</style>
